import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/contractServicePartnerPerson'

function* fetchContractServicePartnerPersonsRefresh() {
  try {
    let fe = JSON.parse(localStorage.getItem('fetchContractServicePartnerPersons'))
    if (fe == null) {
      fe = { size: 10, index: 0, searchTerm: '%20', orderBy: '%20' }
    }
    const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
    yield put({ type: actions.LIST_CONTRACTSERVICEPARTNERPERSON, result })
  } catch (e) {
    console.error('fetchContractServicePartnerPersonsRefresh error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartnerPersons({ size, index, searchTerm, orderBy }) {
  try {
    if (!size && !index && !searchTerm && !orderBy) {
      const fe = JSON.parse(localStorage.getItem('fetchContractServicePartnerPersons'))
      if (fe != null) {
        size = fe.size || 10
        index = fe.index || 0
        searchTerm = fe.searchTerm || '%20'
        orderBy = fe.orderBy || '%20'
      } else {
        size = 10
        index = 0
        searchTerm = '%20'
        orderBy = '%20'
      }
    }
    localStorage.setItem(
      'fetchContractServicePartnerPersons',
      JSON.stringify({ size, index, searchTerm, orderBy }),
    )
    yield put({ type: actions.REQUESTING })
    const result = yield call(list, size, index, searchTerm, orderBy)
    yield put({ type: actions.LIST_CONTRACTSERVICEPARTNERPERSON, result })
  } catch (e) {
    console.error('fetchContractServicePartnerPersons error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartnerPersonEdit({ id }) {
  try {
    yield put({ type: actions.REQUESTING })
    const result = yield call(find, id)
    yield put({ type: actions.EDIT_CONTRACTSERVICEPARTNERPERSON, result })
  } catch (e) {
    console.error('fetchContractServicePartnerPersonEdit error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartnerPersonSave(values) {
  try {
    const result = yield call(save, values)
    if (result !== null) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    }
    yield put({ type: actions.SAVE_CONTRACTSERVICEPARTNERPERSON_RECIEVED, result })
    yield put({ type: actions.RE_FETCH_CONTRACTSERVICEPARTNERPERSONS })
  } catch (e) {
    console.error('fetchContractServicePartnerPersonSave error', e)
    notification.error({ message: 'Save failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractServicePartnerPersonDelete(values) {
  try {
    const result = yield call(remove, values)
    if (result !== null) {
      notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
    }
    yield put({ type: actions.DELETE_CONTRACTSERVICEPARTNERPERSON_RECIEVED, result })
    yield put({ type: actions.RE_FETCH_CONTRACTSERVICEPARTNERPERSONS })
  } catch (e) {
    console.error('fetchContractServicePartnerPersonDelete error', e)
    notification.error({ message: 'Delete failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CONTRACTSERVICEPARTNERPERSONS, fetchContractServicePartnerPersons),
    takeEvery(actions.FETCH_CONTRACTSERVICEPARTNERPERSON, fetchContractServicePartnerPersonEdit),
    takeEvery(actions.SAVE_CONTRACTSERVICEPARTNERPERSON, fetchContractServicePartnerPersonSave),
    takeEvery(actions.DELETE_CONTRACTSERVICEPARTNERPERSON, fetchContractServicePartnerPersonDelete),
    takeEvery(actions.RE_FETCH_CONTRACTSERVICEPARTNERPERSONS, fetchContractServicePartnerPersonsRefresh),
  ])
}
